export const dataTableOptions = {
    print: false,
    download: true,
    filter: false,
    sort: false,
    selectableRows: 'none',
};
